import {
  FETCH_TASKS_REQUEST,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILURE,
} from '../types/taskTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
  total: 0,
  count: 0,
};

const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TASKS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        total: action.payload.objects?.total || 0,
        count: action.payload.objects?.count || 0,
      };
    case FETCH_TASKS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default taskReducer;
